module.exports = __webpack_public_path__ + "static/media/Nexus 6P.a0677f3d.png";